import ScrollWheel from './ScrollWheel';

export default ScrollWheel;

export { ScrollWheel };
